"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentifyUserCommand = void 0;
class IdentifyUserCommand {
    constructor(input) {
        this.input = input;
    }
    execute(config) {
        const { customer, identifyType } = this.input;
        const { cdp: cdpTracking } = config;
        const hashCustomerId = cdpTracking?.helper.md5(customer?.id ?? '');
        if (identifyType === 'User') {
            cdpTracking?.web_event.track('user', 'identify', {
                ...(customer && {
                    dims: {
                        customers: {
                            customer_id: customer?.id ? hashCustomerId : 'no-customer-id',
                            name: customer?.name ?? 'no-customer-name',
                            email: customer?.email?.toLowerCase() ?? 'no-customer-email',
                            phone: customer?.phone ?? 'no-customer-phone',
                            cdp_source: 'Production',
                        },
                    },
                }),
                extra: {},
            });
        }
        else if (identifyType === 'Festival') {
            cdpTracking?.web_event.track('user', 'identify', {
                dims: {
                    ...(customer && {
                        customers: {
                            customer_id: customer?.id ? hashCustomerId : 'no-customer-id',
                            name: customer?.name ?? 'no-customer-name',
                            email: customer?.email ?? 'no-customer-email',
                            phone: customer?.phone ?? 'no-customer-phone',
                            phone_number: customer?.phone ?? 'no-customer-phone-number',
                            city: customer?.region_name ?? 'no-city',
                            district: customer?.district_name ?? 'no-district',
                            ward: customer?.ward_name ?? 'no-ward',
                            address: customer?.address ?? 'no-address',
                        }
                    }),
                },
                extra: {
                    identify_event: 'user_identify_festival',
                    identify_id: customer?.id ? hashCustomerId : 'no-customer-id',
                    identify_time: '{{identify_time}}',
                },
            });
        }
        return Promise.resolve();
    }
}
exports.IdentifyUserCommand = IdentifyUserCommand;
